import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { PersonIcon } from '@winelidays/wld-tsx-2/images';
import PracticalLine from '../PracticalLine';
const getContent = ({ informations, translate }) => {
    if (!('participants' in informations)) {
        return null;
    }
    const min = informations.participants.lower;
    const max = informations.participants.upper;
    if (min && max) {
        if (min === max) {
            return translate('practical.participants.exact', { number: min, long: true });
        }
        return translate('practical.participants.from_min_max', {
            min: informations.participants.lower,
            max: informations.participants.upper,
            long: true
        });
    }
    if (min) {
        return translate('practical.participants.min', { min, long: true });
    }
    return translate('practical.participants.max', { max, long: true });
};
const ParticipantsNumberContent = (t0) => {
    const $ = _c(5);
    const { informations } = t0;
    const translate = useTranslate();
    let t1;
    if ($[0] !== informations || $[1] !== translate) {
        t1 = getContent({ informations, translate });
        $[0] = informations;
        $[1] = translate;
        $[2] = t1;
    }
    else {
        t1 = $[2];
    }
    const content = t1;
    let t2;
    if ($[3] !== content) {
        t2 = content ? <PracticalLine icon={<PersonIcon />} content={content}/> : null;
        $[3] = content;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default ParticipantsNumberContent;
